module.exports = __webpack_public_path__ + "static/media/Ionicons.b2e0fc82.ttf";